import { useMemo } from 'preact/compat';

import { AnyCard } from '@/queries/cards/types';
import { useSelector } from '@/redux/helper';
import { selectCanAccessEducatorsApp } from '@/redux/selectors/users';

// eslint-disable-next-line import/prefer-default-export
export const useAccessibleCards = (cards: AnyCard[] | undefined): AnyCard[] | undefined => {
  const canAccessEducatorsApp = useSelector(selectCanAccessEducatorsApp);
  return useMemo(() => {
    if (!canAccessEducatorsApp) {
      return cards?.filter((card) => card.type !== 'LESSON_CARD_TYPE' && card.type !== 'BROWSE_LESSONS_CARD_TYPE');
    }
    return cards;
  }, [cards, canAccessEducatorsApp]);
};
